import * as autosize from "autosize";

import * as Autocomplete from "./autocomplete";

$(function () {
  $(document).on("click", ".dynamic-list ~ .add-field", onAddField).on("click", ".dynamic-list .delete-field", onDeleteField);
});

//------------------------------------------------------------------------------
// onAddField
//------------------------------------------------------------------------------
function onAddField(e) {
  e.preventDefault();
  let $list = $(this).prev(".dynamic-list");
  let firstItem = $list.find("li").first(); // The first element serves as templates
  if (firstItem.length === 0) {
    firstItem = $list.data("_emptyTemplate");
    if (!firstItem) return;
  }
  let $newItem = firstItem.clone();
  $list.append($newItem);

  renumberAllDynamicInputs();

  // Reset the forms, unless it's a checkbox
  $newItem.find("textarea, input").each(function () {
    if ($(this).parents(".checkbox").length == 0) {
      $(this).val("");
    }
  });
  $newItem.find("select").first()[0]?.options[0].setAttribute("selected", "selected");
  $newItem.find("textarea, input")[0]?.focus();
  autosize($(".autoresize"));
  if ($newItem.find("[data-autocomplete]").length > 0) {
    Autocomplete.createOnLoad($newItem);
  }

  const newItemEl = $newItem[0];
  $list.trigger("dynamic_list_changed", { added: newItemEl });
  $list[0].dispatchEvent(addedEvent(newItemEl));
}

//------------------------------------------------------------------------------
// onDeleteField
//------------------------------------------------------------------------------
function onDeleteField(e) {
  e.preventDefault();
  let $list = $(this).parents(".dynamic-list").first();
  let removedItem = $(this).closest("li");
  let idInput = removedItem.prev("input[type=hidden]");
  if ($list.children("li").length === 1) {
    $list.data("_emptyTemplate", removedItem.clone());
  }
  removedItem.remove();
  idInput.remove();
  renumberAllDynamicInputs();

  $list.trigger("dynamic_list_changed", { removed: removedItem });
  $list[0].dispatchEvent(removedEvent(removedItem));
}

//------------------------------------------------------------------------------
// renumberAllDynamicInputs
//------------------------------------------------------------------------------
function renumberAllDynamicInputs() {
  $(".dynamic-list")
    .filter(function () {
      return $(this).parents(".dynamic-list").length == 0;
    })
    .each(function () {
      renumberDynamicInputs($(this), null);
    });
}

function renumberDynamicInputs($list, parentIndex) {
  // remove all id inputs
  $list.find("input[name$='][id]']").remove();

  // Use the first item to get a template for the id and the name
  // We are sure it's numbered 0
  let firstItem = $list.children("li").first();
  let idTemplates = [];
  let nameTemplates = [];
  $("input, textarea, select", firstItem)
    .filter(function () {
      return $(this).parents(".dynamic-list")[0] == $list[0];
    })
    .each(function () {
      idTemplates.push($(this).prop("id"));
      nameTemplates.push($(this).prop("name"));
    });

  // Renumber the items, replacing 0 with the incremented count
  $list.children("li").each(function (i) {
    $("input,  textarea, select", this)
      .filter(function () {
        return $(this).parents(".dynamic-list")[0] == $list[0];
      })
      .each(function (j) {
        let newId, newName;
        if (parentIndex !== null) {
          newId = idTemplates[j].replace(/_\d+_/, `_${parentIndex}_`);
          let cutIndex = newId.indexOf(`_${parentIndex}_`) + 1;
          let prefix = newId.substr(0, cutIndex);
          let rest = newId.substr(cutIndex, 999999999999);
          newId = prefix + rest.replace(/_\d+_/, `_${i}_`);

          newName = nameTemplates[j].replace(/\[\d+\]/, `[${parentIndex}]`);
          cutIndex = newName.indexOf(`[${parentIndex}]`) + 1;
          prefix = newName.substr(0, cutIndex);
          rest = newName.substr(cutIndex, 999999999999);
          newName = prefix + rest.replace(/\[\d+\]/, `[${i}]`);
        } else {
          newId = idTemplates[j].replace(/_\d+_/, `_${i}_`);
          newName = nameTemplates[j].replace(/\[\d+\]/, `[${i}]`);
        }
        $(this).prop("id", newId).prop("name", newName);
      });

    // Renumber the include dynamic list
    $(".dynamic-list", this).each(function () {
      renumberDynamicInputs($(this), i);
    });
  });
}

/**
 * Add a callback to be called when the list changes.
 *
 * The custom event details one of the following objects, depending on the event type:
 *
 * - `{ type: EVENT_TYPE_ADD, added: HTMLElement }`
 * - `{ type: EVENT_TYPE_REMOVE, removed: HTMLElement }`
 *
 * @param {HTMLElement} listEl - The list element, having the class "dynamic-list"
 * @param {(event: CustomEvent) => void} callback - The callback to be called when the list changes
 */
export function onChange(listEl, callback) {
  listEl.addEventListener("dynamic_list_changed", callback);
}

export const EVENT_TYPE_ADD = "add";
export const EVENT_TYPE_REMOVE = "remove";

function addedEvent(newItem) {
  return new CustomEvent("dynamic_list_changed", {
    bubbles: true,
    detail: {
      type: EVENT_TYPE_ADD,
      added: newItem,
    },
  });
}

function removedEvent(removedItem) {
  return new CustomEvent("dynamic_list_changed", {
    bubbles: true,
    detail: {
      type: EVENT_TYPE_REMOVE,
      removed: removedItem,
    },
  });
}
